import { explorerPaths } from '@mirinae/defines/paths';

let _rootDomain;
let _cookieDomain;
// if (!process.env.REACT_APP_IS_ALPHA && (process.env.REACT_APP_MODE === 'LOCAL' || process.env.REACT_APP_LOCAL)) { //  HEY, need to be able to recognize app source for  localhost testing!!  only way now is https://[app.]local.mirinae.io with local Nginx SSL terminator

if (window.location.hostname.match(/local/)) {
	_rootDomain = 'localhost';
    _cookieDomain = 'localhost';
} else {
    // hostname, not host: host carries a port (alpha.mirinae.io:8443) and the match returns null
    _rootDomain = window.location.hostname.match(/((.+\.)|(^))([a-z\-]+\.[a-z][a-z][a-z]*)$/)[4];
    _cookieDomain = `.${_rootDomain}`;
}

export const rootDomain = _rootDomain;
export const cookieDomain = _cookieDomain;

// Not the full address: it can carry an invitation token after `#` (#30), and this runs before any page
// has had the chance to take it out.
console.log('rootDomain', rootDomain, 'cookieDomain', cookieDomain);

// build external URL, including any flutter app version parameter, so other services know app version
export const buildExternalURL = (path, versionParam) => {
    const vp = versionParam || window.versionParam || window.appVersion;
    const qpSep = path.indexOf('?') > 0 ? '&' : path.endsWith('/') ? '?' : '/?';
    return vp ? `${path}${qpSep}v=${vp}` : path;
}

export const ExternalLinks = {
    mirinaeCompany: explorerPaths.about,
    TermsAndConditions: explorerPaths.termsAndConditions,
    PrivacyPolicy: explorerPaths.privacyPolicy,
    EULA: explorerPaths.eula,

    TTMIK: 'https://talktomeinkorean.com/',
    howToStudyKorean: 'https://www.howtostudykorean.com/',
    krdictCopyright: 'https://krdict.korean.go.kr/eng/kboardPolicy/copyRightTermsInfo?nation=eng',
    naverCorp: 'https://developers.naver.com/products/terms/',
    khaiii: 'https://github.com/kakao/khaiii',
    apache2: 'https://www.apache.org/licenses/LICENSE-2.0',

    chromeExtensionMarket: 'https://chrome.google.com/webstore/detail/mirinae-for-chrome/nagkhplkbmnpanjfjpoepjmikmegcihp',
    chromeExtensionManifest: 'chrome-extension://nagkhplkbmnpanjfjpoepjmikmegcihp/manifest.json',
    tutorialVideo: 'https://www.youtube.com/watch?v=df7YD6EuZHw',
    survey: 'https://forms.gle/gyN2ux9Kp9cVUcwQA',

    sns: {
        twitter: 'https://twitter.com/mirinae_io',
        facebook: 'https://www.facebook.com/mirinae.io',
        youtube: 'https://www.youtube.com/c/mirinae_io',
        instagram: 'https://www.instagram.com/mirinae.io/',
        linkedIn: 'https://www.linkedin.com/company/mirinae',
        pinterest: 'https://www.pinterest.co.kr/mirinaean',
    },
    email: 'team@mirinae.io',
    app: {
        apple: 'https://apps.apple.com/kr/app/mirinae-explorer/id1564646065',
        android: `intent://${window.location.href.replace(window.location.protocol, '').replace('//', '')}#Intent;scheme=https;package=com.mirinae.mirinae;end`,
        playStore: 'https://play.google.com/store/apps/details?id=com.mirinae.mirinae',
    },

    communityGuide: explorerPaths.communityGuidelines,
    // support still points off-site: explorerRoutes.js on this branch redirects the /help route to this
    // same value, so pointing it at explorerPaths.help here would create a redirect loop. Safe to switch
    // once the Help Center route (help-center branch) lands and /help serves its own page directly.
    support: 'https://support.mirinae.io/',
    userFeedback: explorerPaths.feedback,
    help: explorerPaths.help,
    glossary: explorerPaths.glossary,
};
